import { useState } from "react";

export interface FaqItem {
  id: string;
  q: string;
  a: string;
}

interface FaqAccordionProps {
  items: FaqItem[];
  defaultOpenId?: string;
}

export default function FaqAccordion({ items, defaultOpenId }: FaqAccordionProps) {
  const [openId, setOpenId] = useState<string | null>(defaultOpenId ?? null);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item) => {
        const open = openId === item.id;
        return (
          <article key={item.id} className="py-1">
            <h3 className="m-0">
              <button
                type="button"
                onClick={() => setOpenId(open ? null : item.id)}
                aria-expanded={open}
                className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer group"
              >
                <span
                  className={`font-heading text-base md:text-lg font-semibold leading-snug transition-colors ${
                    open ? "text-primary-700" : "text-foreground-900 group-hover:text-primary-700"
                  }`}
                >
                  {item.q}
                </span>
                <span
                  className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-lg transition-all ${
                    open
                      ? "bg-primary-500 text-background-50 rotate-45"
                      : "bg-background-100 text-foreground-600 group-hover:bg-primary-100 group-hover:text-primary-700"
                  }`}
                >
                  <i className="ri-add-line"></i>
                </span>
              </button>
            </h3>
            {open && (
              <div className="pb-6 pr-12 -mt-1">
                <p className="text-[15px] leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            )}
          </article>
        );
      })}
    </div>
  );
}